import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PaymentEventImportsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPaymentEventImport = (data): any => action(types.CREATE_PAYMENT_EVENT_IMPORT_REQUESTED, data);

export const updatePaymentEventImport = (data): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_REQUESTED, data);

export const deletePaymentEventImport = (paymentEventImportId): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_REQUESTED, paymentEventImportId);

export const getPaymentEventImport = (paymentEventImportId): any => action(types.GET_PAYMENT_EVENT_IMPORT_REQUESTED, paymentEventImportId);

export const getAllPaymentEventImports = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYMENT_EVENT_IMPORTS_REQUESTED, {
  pagination,
  compile,
});

export const selectPaymentEventImport = (paymentEventImportId): any => action(types.SELECT_PAYMENT_EVENT_IMPORT_REQUESTED, {
  currentPaymentEventImportId: paymentEventImportId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPaymentEventImportPending: (payload): any => action(types.CREATE_PAYMENT_EVENT_IMPORT_PENDING, payload),
  createPaymentEventImportSuccess: (response): any => {
    const currentPaymentEventImport = response.entities.paymentEventImports[response.result];
    // history.push(`/payment/${currentPaymentEventImport.paymentCollection.id}/review`);
    return action(types.CREATE_PAYMENT_EVENT_IMPORT_SUCCESS, {
      paymentEventImportsById: response.entities.paymentEventImports,
      currentPaymentEventImportId: response.result,
    });
  },
  createPaymentEventImportFailed: (error): any => action(types.CREATE_PAYMENT_EVENT_IMPORT_FAIL, { backendErrors: error }),
  updatePaymentEventImportPending: (payload): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_PENDING, payload),
  updatePaymentEventImportSuccess: (response): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_SUCCESS, {
    paymentEventImportsById: response.entities.paymentEventImports,
    currentPaymentEventImportId: response.result,
  }),
  updatePaymentEventImportFailed: (error): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_FAIL, { backendErrors: error }),
  deletePaymentEventImportPending: (): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_PENDING, {}),
  deletePaymentEventImportSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPaymentEventImportId: null });
    history.push('/paymentEventImports');

    return action(types.DELETE_PAYMENT_EVENT_IMPORT_SUCCESS, {
      currentPaymentEventImportId: response,
    });
  },
  getPaymentEventImportPending: (): any => action(types.GET_PAYMENT_EVENT_IMPORT_PENDING, {}),
  getPaymentEventImportSuccess: (response): any => action(types.GET_PAYMENT_EVENT_IMPORT_SUCCESS, {
    paymentEventImportsById: response.entities.paymentEventImports,
    currentPaymentEventImportId: response.result,
  }),
  getPaymentEventImportFailed: (error): any => action(types.GET_PAYMENT_EVENT_IMPORT_FAIL, { backendErrors: error }),
  deletePaymentEventImportFailed: (error): any => action(types.UPDATE_PAYMENT_EVENT_IMPORT_FAIL, { backendErrors: error }),
  getAllPaymentEventImportsPending: (pagination): any => action(types.GET_ALL_PAYMENT_EVENT_IMPORTS_PENDING, { pagination }),
  getAllPaymentEventImportsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENT_EVENT_IMPORTS_SUCCESS, {
    paymentEventImportsById: response.entities.paymentEventImports,
    paymentEventImportIds: response.result,
    meta,
  }),
  getAllPaymentEventImportsFailed: (error): any => action(types.GET_ALL_PAYMENT_EVENT_IMPORTS_FAIL, { backendErrors: error }),
};

export default null;
